import React from 'react'

const PageCard = ({ children , className }) => {
  return (
    <div className={`${className} py-5 bg-white rounded-xl`}>
        {children}
    </div>
  )
}

export default PageCard